import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const thousandFormat = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0
})

const authorFollowerResolver: FieldResolver = (metadata: Metadata) => {
  let authorFollower: string | number | undefined = metadata.getAuthorFollower()
  if (authorFollower) {
    authorFollower = thousandFormat.format(authorFollower)
  }

  return { authorFollower } as StreamData
}

export default authorFollowerResolver
